/* eslint-disable @typescript-eslint/no-redeclare */
// MT4 counterparts

export const OPEN_TRADE = 'OPEN_TRADE'
export type OPEN_TRADE = typeof OPEN_TRADE

export const BUY_BOND = 'BUY_BOND'
export type BUY_BOND = typeof BUY_BOND

export const BOND_BUY_MODE_CASH = 'BOND_BUY_MODE_CASH'
export const BOND_BUY_MODE_PRINCIPAL = 'BOND_BUY_MODE_PRINCIPAL'

export const CHANGE_BOND_BUY_MODE = 'CHANGE_BOND_BUY_MODE'
export type CHANGE_BOND_BUY_MODE = typeof CHANGE_BOND_BUY_MODE

export const SHOW_BOND_DETAIL_DIALOG = 'SHOW_BOND_DETAIL_DIALOG'
export type SHOW_BOND_DETAIL_DIALOG = typeof SHOW_BOND_DETAIL_DIALOG

export const HIDE_BOND_DETAIL_DIALOG = 'HIDE_BOND_DETAIL_DIALOG'
export type HIDE_BOND_DETAIL_DIALOG = typeof HIDE_BOND_DETAIL_DIALOG

export const FULFILL_TICK = 'FULFILL_TICK'
export type FULFILL_TICK = typeof FULFILL_TICK

export const FULFILL_OPEN_TRADE = 'FULFILL_OPEN_TRADE'
export type FULFILL_OPEN_TRADE = typeof FULFILL_OPEN_TRADE

export const FULFILL_PENDING_TRADE = 'FULFILL_PENDING_TRADE'
export type FULFILL_PENDING_TRADE = typeof FULFILL_PENDING_TRADE

export const FULFILL_ACTIVATED_TRADE = 'FULFILL_ACTIVATED_TRADE'
export type FULFILL_ACTIVATED_TRADE = typeof FULFILL_ACTIVATED_TRADE

export const CLOSE_TRADE = 'CLOSE_TRADE'
export type CLOSE_TRADE = typeof CLOSE_TRADE

export const CLOSE_BOND_TRADE = 'CLOSE_BOND_TRADE'
export type CLOSE_BOND_TRADE = typeof CLOSE_BOND_TRADE

export const FULFILL_CLOSE_TRADE = 'FULFILL_CLOSE_TRADE'
export type FULFILL_CLOSE_TRADE = typeof FULFILL_CLOSE_TRADE

export const CLOSE_ALL_TRADES = 'CLOSE_ALL_TRADES'
export type CLOSE_ALL_TRADES = typeof CLOSE_ALL_TRADES

export const MODIFY_TRADE = 'MODIFY_TRADE'
export type MODIFY_TRADE = typeof MODIFY_TRADE

export const MODIFY_TRADES = 'MODIFY_TRADES'
export type MODIFY_TRADES = typeof MODIFY_TRADES

export const FULFILL_MODIFY_TRADE = 'FULFILL_MODIFY_TRADE'
export type FULFILL_MODIFY_TRADE = typeof FULFILL_MODIFY_TRADE

export const FULFILL_CURRENT_PRICES = 'FULFILL_CURRENT_PRICES'
export type FULFILL_CURRENT_PRICES = typeof FULFILL_CURRENT_PRICES

export const FULFILL_BALANCE_UPDATE = 'FULFILL_BALANCE_UPDATE'
export type FULFILL_BALANCE_UPDATE = typeof FULFILL_BALANCE_UPDATE

export const FULFILL_LOGIN = 'FULFILL_LOGIN'
export type FULFILL_LOGIN = typeof FULFILL_LOGIN

export const DO_LOGIN = 'DO_LOGIN'
export type DO_LOGIN = typeof DO_LOGIN

export const FULFILL_PRICES = 'FULFILL_PRICES'
export type FULFILL_PRICES = typeof FULFILL_PRICES

export const FULFILL_CURRENT_MARKET_STATE = 'FULFILL_CURRENT_MARKET_STATE'
export type FULFILL_CURRENT_MARKET_STATE = typeof FULFILL_CURRENT_MARKET_STATE

export const FULFILL_ASSET_GROUPS = 'FULFILL_ASSET_GROUPS'
export type FULFILL_ASSET_GROUPS = typeof FULFILL_ASSET_GROUPS

export const FULFILL_OPEN_PENDING_ORDER = 'FULFILL_OPEN_PENDING_ORDER'
export type FULFILL_OPEN_PENDING_ORDER = typeof FULFILL_OPEN_PENDING_ORDER

export const CANCEL_PENDING_ORDER = 'CANCEL_PENDING_ORDER'
export type CANCEL_PENDING_ORDER = typeof CANCEL_PENDING_ORDER

export const FULFILL_CANCEL_PENDING_ORDER = 'FULFILL_CANCEL_PENDING_ORDER'
export type FULFILL_CANCEL_PENDING_ORDER = typeof FULFILL_CANCEL_PENDING_ORDER

export const FULFILL_MODIFY_PENDING_TRADE = 'FULFILL_MODIFY_PENDING_TRADE'
export type FULFILL_MODIFY_PENDING_TRADE = typeof FULFILL_MODIFY_PENDING_TRADE

// Trader panel
export const TOGGLE_POSITIONS = 'TOGGLE_POSITIONS'
export type TOGGLE_POSITIONS = typeof TOGGLE_POSITIONS

export const TOGGLE_ASSETS = 'TOGGLE_ASSETS'
export type TOGGLE_ASSETS = typeof TOGGLE_ASSETS

export const SET_ASSETS_GROUP = 'SET_ASSETS_GROUP'
export type SET_ASSETS_GROUP = typeof SET_ASSETS_GROUP

export const TOGGLE_TRADING_PANE = 'TOGGLE_TRADING_PANE'
export type TOGGLE_TRADING_PANE = typeof TOGGLE_TRADING_PANE

export const OPEN_EDIT_PANE = 'OPEN_EDIT_PANE'
export type OPEN_EDIT_PANE = typeof OPEN_EDIT_PANE

export const SET_DEPOSIT = 'SET_DEPOSIT'
export type SET_DEPOSIT = typeof SET_DEPOSIT

export const SET_TRADE_TYPE = 'SET_TRADE_TYPE'
export type SET_TRADE_TYPE = typeof SET_TRADE_TYPE

export const SET_AMOUNT = 'SET_AMOUNT'
export type SET_AMOUNT = typeof SET_AMOUNT

export const INPUT_AMOUNT = 'INPUT_AMOUNT'
export type INPUT_AMOUNT = typeof INPUT_AMOUNT

export const SET_BOND_AMOUNT = 'SET_BOND_AMOUNT'
export type SET_BOND_AMOUNT = typeof SET_BOND_AMOUNT

export const SET_TAKEPROFIT = 'SET_TAKEPROFIT'
export type SET_TAKEPROFIT = typeof SET_TAKEPROFIT

export const SET_STOPLOSS = 'SET_STOPLOSS'
export type SET_STOPLOSS = typeof SET_STOPLOSS

export const SET_PRICE = 'SET_PRICE'
export type SET_PRICE = typeof SET_PRICE

export const INPUT_POSITION_TAKEPROFIT = 'INPUT_POSITION_TAKEPROFIT'
export type INPUT_POSITION_TAKEPROFIT = typeof INPUT_POSITION_TAKEPROFIT

export const INPUT_POSITION_STOPLOSS = 'INPUT_POSITION_STOPLOSS'
export type INPUT_POSITION_STOPLOSS = typeof INPUT_POSITION_STOPLOSS

export const INPUT_POSITION_PRICE = 'INPUT_POSITION_PRICE'
export type INPUT_POSITION_PRICE = typeof INPUT_POSITION_PRICE

export const UPDATE_PRICES = 'UPDATE_PRICES'
export type UPDATE_PRICES = typeof UPDATE_PRICES

export const CHANGE_SYMBOL = 'CHANGE_SYMBOL'
export type CHANGE_SYMBOL = typeof CHANGE_SYMBOL

export const SET_TRADING_SYMBOL = 'SET_TRADING_SYMBOL'
export type SET_TRADING_SYMBOL = typeof SET_TRADING_SYMBOL

export const TRIGGER_POST_COMMAND = 'TRIGGER_POST_COMMAND'
export type TRIGGER_POST_COMMAND = typeof TRIGGER_POST_COMMAND

export const APPLY_POST_COMMAND = 'APPLY_POST_COMMAND'
export type APPLY_POST_COMMAND = typeof APPLY_POST_COMMAND

export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE'
export type SHOW_ERROR_MESSAGE = typeof SHOW_ERROR_MESSAGE

export const SHOW_SUCCESS_MESSAGE = 'SHOW_SUCCESS_MESSAGE'
export type SHOW_SUCCESS_MESSAGE = typeof SHOW_SUCCESS_MESSAGE

export const SHOW_SOKET_ERROR_MESSAGE = 'SHOW_SOKET_ERROR_MESSAGE'
export type SHOW_SOKET_ERROR_MESSAGE = typeof SHOW_SOKET_ERROR_MESSAGE

export const SELECT_ACCOUNT = 'SELECT_ACCOUNT'
export type SELECT_ACCOUNT = typeof SELECT_ACCOUNT

export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE'
export type SET_ACCOUNT_TYPE = typeof SET_ACCOUNT_TYPE

export const SET_ACCOUNT = 'SET_ACCOUNT'
export type SET_ACCOUNT = typeof SET_ACCOUNT

export const CONNECTION_REESTABLISHED = 'CONNECTION_REESTABLISHED'
export type CONNECTION_REESTABLISHED = typeof CONNECTION_REESTABLISHED

export const REFRESH_SUBSCRIBED_SYMBOLS = 'REFRESH_SUBSCRIBED_SYMBOLS'
export type REFRESH_SUBSCRIBED_SYMBOLS = typeof REFRESH_SUBSCRIBED_SYMBOLS

export const RESUBSCRIBED_SYMBOLS = 'RESUBSCRIBED_SYMBOLS'
export type RESUBSCRIBED_SYMBOLS = typeof RESUBSCRIBED_SYMBOLS

// calculations
export const REFRESH_TOTAL_PL = 'REFRESH_TOTAL_PL'
export type REFRESH_TOTAL_PL = typeof REFRESH_TOTAL_PL

export const REFRESH_ACCOUNT_VALUES = 'REFRESH_ACCOUNT_VALUES'
export type REFRESH_ACCOUNT_VALUES = typeof REFRESH_ACCOUNT_VALUES

export const REFRESH_TRADING_VALUES = 'REFRESH_TRADING_VALUES'
export type REFRESH_TRADING_VALUES = typeof REFRESH_TRADING_VALUES

export const REFRESH_TRADES = 'REFRESH_TRADES'
export type REFRESH_TRADES = typeof REFRESH_TRADES

// graphQL
export const INIT_GRAPH_QL_REPO = 'INIT_GRAPH_QL_REPO'
export type INIT_GRAPH_QL_REPO = typeof INIT_GRAPH_QL_REPO

export const GET_CLOSED_POSITIONS = 'GET_CLOSED_POSITIONS'
export type GET_CLOSED_POSITIONS = typeof GET_CLOSED_POSITIONS

export const FULFILL_GET_CLOSED_POSITIONS = 'FULFILL_GET_CLOSED_POSITIONS'
export type FULFILL_GET_CLOSED_POSITIONS = typeof FULFILL_GET_CLOSED_POSITIONS

export const GET_USER_ACCOUNT = 'GET_USER_ACCOUNT'
export type GET_USER_ACCOUNT = typeof GET_USER_ACCOUNT
export const GET_USER_TRADING_ACCOUNTS = 'GET_USER_TRADING_ACCOUNTS'
export type GET_USER_TRADING_ACCOUNTS = typeof GET_USER_TRADING_ACCOUNTS

export const FULFILL_USER_ACCOUNT = 'FULFILL_USER_ACCOUNT'
export type FULFILL_USER_ACCOUNT = typeof FULFILL_USER_ACCOUNT

export const GET_ALLOWED_LEVERAGES = 'GET_ALLOWED_LEVERAGES'
export type GET_ALLOWED_LEVERAGES = typeof GET_ALLOWED_LEVERAGES

export const FULFILL_GET_ALLOWED_LEVERAGES = 'FULFILL_GET_ALLOWED_LEVERAGES'
export type FULFILL_GET_ALLOWED_LEVERAGES = typeof FULFILL_GET_ALLOWED_LEVERAGES

export const GET_TRANSLATIONS = 'GET_TRANSLATIONS'
export type GET_TRANSLATIONS = typeof GET_TRANSLATIONS

export const GET_FAVOURITES = 'GET_FAVOURITES'
export type GET_FAVOURITES = typeof GET_FAVOURITES

export const FULFILL_GET_FAVOURITES = 'FULFILL_GET_FAVOURITES'
export type FULFILL_GET_FAVOURITES = typeof FULFILL_GET_FAVOURITES

export const UPDATE_FAVOURITES = 'UPDATE_FAVOURITES'
export type UPDATE_FAVOURITES = typeof UPDATE_FAVOURITES

export const FULFILL_UPDATE_FAVOURITES = 'FULFILL_UPDATE_FAVOURITES'
export type FULFILL_UPDATE_FAVOURITES = typeof FULFILL_UPDATE_FAVOURITES

// common
export const INIT_APP = 'INIT_APP'
export type INIT_APP = typeof INIT_APP

export const APP_INITIALIZED = 'APP_INITIALIZED'
export type APP_INITIALIZED = typeof APP_INITIALIZED

export const UPDATE_TRADING_VALUES = 'UPDATE_TRADING_VALUES'
export type UPDATE_TRADING_VALUES = typeof UPDATE_TRADING_VALUES

export const CLEAR_STATE = 'CLEAR_STATE'
export type CLEAR_STATE = typeof CLEAR_STATE

export const CHART_READY = 'CHART_READY'
export type CHART_READY = typeof CHART_READY

export const SET_CHART_MODE = 'SET_CHART_MODE'
export type SET_CHART_MODE = typeof SET_CHART_MODE

export const REFRESH_CHART = 'REFRESH_CHART'
export type REFRESH_CHART = typeof REFRESH_CHART

export const SELECT_POSITION = 'SELECT_POSITION'
export type SELECT_POSITION = typeof SELECT_POSITION

export const SELECT_ORDER = 'SELECT_ORDER'
export type SELECT_ORDER = typeof SELECT_ORDER

export const SET_POSITIONS_MODE = 'SET_POSITIONS_MODE'
export type SET_POSITIONS_MODE = typeof SET_POSITIONS_MODE

export const SET_LOCALE = 'SET_LOCALE'
export type SET_LOCALE = typeof SET_LOCALE

export const SET_APP_MODE = 'SET_APP_MODE'
export type SET_APP_MODE = typeof SET_APP_MODE

export const SET_APP_THEME = 'SET_APP_THEME'
export type SET_APP_THEME = typeof SET_APP_THEME

export const SET_TRADING_SIGNAL = 'SET_TRADING_SIGNAL'
export type SET_TRADING_SIGNAL = typeof SET_TRADING_SIGNAL

export const CLEAR_TRADING_SIGNAL = 'CLEAR_TRADING_SIGNAL'
export type CLEAR_TRADING_SIGNAL = typeof CLEAR_TRADING_SIGNAL

// mt4
export const LOGIN_TO_MT4 = 'LOGIN_TO_MT4'
export type LOGIN_TO_MT4 = typeof LOGIN_TO_MT4

export const RELOGIN_TO_MT4 = 'RELOGIN_TO_MT4'
export type RELOGIN_TO_MT4 = typeof RELOGIN_TO_MT4

export const MT4_TIMEOUT: number = 15000

// bonds
export const INIT_BONDS_CONFIG = 'INIT_BONDS_CONFIG'
export type INIT_BONDS_CONFIG = typeof INIT_BONDS_CONFIG

export const SELECT_BOND = 'SELECT_BOND'
export type SELECT_BOND = typeof SELECT_BOND

export const VIEW_BOND_DETAILS = 'VIEW_BOND_DETAILS'
export type VIEW_BOND_DETAILS = typeof VIEW_BOND_DETAILS

export const CLOSE_BOND_DETAILS = 'CLOSE_BOND_DETAILS'
export type CLOSE_BOND_DETAILS = typeof CLOSE_BOND_DETAILS

export const CLEAR_SELECT_BOND = 'CLEAR_SELECT_BOND'
export type CLEAR_SELECT_BOND = typeof CLEAR_SELECT_BOND

export const GET_BOND_CONFIG = 'GET_BOND_CONFIG'
export type GET_BOND_CONFIG = typeof GET_BOND_CONFIG

export const FULFILL_BOND_CONFIG = 'FULFILL_BOND_CONFIG'
export type FULFILL_BOND_CONFIG = typeof FULFILL_BOND_CONFIG

export const FULFILL_BONDS = 'FULFILL_BONDS'
export type FULFILL_BONDS = typeof FULFILL_BONDS

export const UPDATE_BOND_TRADING_PANE = 'UPDATE_BOND_TRADING_PANE'
export type UPDATE_BOND_TRADING_PANE = typeof UPDATE_BOND_TRADING_PANE

export const BOND_LENDING_RATE = 0.03 // 3%

export const FULFILL_SIGNALS = 'FULFILL_SIGNALS'
export type FULFILL_SIGNALS = typeof FULFILL_SIGNALS

export const FULFILL_CANDLES_DATA = 'FULFILL_CANDLES_DATA'
export type FULFILL_CANDLES_DATA = typeof FULFILL_CANDLES_DATA

export const FULFILL_SIGNAL = 'FULFILL_SIGNAL'
export type FULFILL_SIGNAL = typeof FULFILL_SIGNAL

export const FULFILL_EXPIRED_SIGNALS = 'FULFILL_EXPIRED_SIGNALS'
export type FULFILL_EXPIRED_SIGNALS = typeof FULFILL_EXPIRED_SIGNALS

export const FULFILL_SIMPLE_SIGNALS = 'FULFILL_SIMPLE_SIGNALS'
export type FULFILL_SIMPLE_SIGNALS = typeof FULFILL_SIMPLE_SIGNALS

export const FULFILL_TELEGRAM_SIGNALS = 'FULFILL_TELEGRAM_SIGNALS'
export type FULFILL_TELEGRAM_SIGNALS = typeof FULFILL_TELEGRAM_SIGNALS

export const DISMISS_RISC_DISCLAIMER = 'DISMISS_RISC_DISCLAIMER'
export type DISMISS_RISC_DISCLAIMER = typeof DISMISS_RISC_DISCLAIMER
